"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPES_PANEL_WIDTH = void 0;
exports.AddTypeModal = AddTypeModal;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const typesTreeModel_1 = require("./typesTreeModel");
/**
 * Szerokość panelu bocznego. Ta sama liczba zwęża obszar drzewa w `TypesTreeView`,
 * żeby drzewo przeliczyło się na węższe miejsce, zamiast schować się pod panelem.
 *
 * 420 px to szerokość panelu `InlineCreateDrawer` - jedynego drugiego panelu bocznego
 * z formularzem w tej aplikacji. Jedna liczba dla obu, żeby panele nie różniły się
 * bez powodu (decyzja ownera 2026-08-24).
 */
exports.TYPES_PANEL_WIDTH = 420;
/**
 * Dodawanie i edycja typu kamienia milowego albo typu sprawy.
 *
 * Numer folderu przy kamieniu należy do POWIĄZANIA z typem umowy, nie do samego
 * kamienia - dlatego formularz kamienia zawsze pracuje w kontekście wybranego
 * typu umowy i zapisuje oba rekordy naraz.
 *
 * Kamienia przy typie sprawy NIE da się zmienić: przeniesienie typu pod inny
 * kamień zostawiłoby istniejące sprawy przypięte do typu wiszącego gdzie indziej.
 */
function AddTypeModal({ kind, editTarget, data, contractTypeId, defaultMilestoneTypeId, isSaving, error, onClose, onSubmit, }) {
    const [name, setName] = (0, react_1.useState)("");
    const [description, setDescription] = (0, react_1.useState)("");
    const [folderNumber, setFolderNumber] = (0, react_1.useState)("");
    const [isDefault, setIsDefault] = (0, react_1.useState)(false);
    const [isUnique, setIsUnique] = (0, react_1.useState)(false);
    const [isSubCaseOnly, setIsSubCaseOnly] = (0, react_1.useState)(false);
    const [parentCaseTypeIds, setParentCaseTypeIds] = (0, react_1.useState)([]);
    const [milestoneTypeId, setMilestoneTypeId] = (0, react_1.useState)("");
    const [templateName, setTemplateName] = (0, react_1.useState)("");
    const [templateDescription, setTemplateDescription] = (0, react_1.useState)("");
    const [taskTemplates, setTaskTemplates] = (0, react_1.useState)([]);
    const [wasSubmitted, setWasSubmitted] = (0, react_1.useState)(false);
    const isEditing = !!editTarget;
    /** Podpinanie istniejącego typu - własny, krótki formularz zamiast pól typu. */
    const isAttach = !editTarget && kind === "attachMilestoneType";
    const isMilestone = (editTarget ? editTarget.kind : kind) === "milestoneType";
    /** Numer folderu kamienia leży na krawędzi z wybranym typem umowy. */
    const milestoneEdge = editTarget?.kind === "milestoneType" && contractTypeId !== null
        ? data.contractTypeMilestoneTypes.find((edge) => edge.contractTypeId === contractTypeId &&
            edge.milestoneTypeId === editTarget.entity.id)
        : undefined;
    (0, react_1.useEffect)(() => {
        if (!kind && !editTarget)
            return;
        setWasSubmitted(false);
        if (editTarget?.kind === "milestoneType") {
            const entity = editTarget.entity;
            setName(entity.name);
            setDescription(entity.description ?? "");
            setFolderNumber(milestoneEdge?.folderNumber ?? "");
            setIsDefault(!!milestoneEdge?.isDefault);
            setIsUnique(!!entity.isUniquePerContract);
            setIsSubCaseOnly(false);
            setMilestoneTypeId("");
            setTemplateName(entity._templateName ?? "");
            setTemplateDescription(entity._templateDescription ?? "");
            setTaskTemplates([]);
            return;
        }
        if (editTarget?.kind === "caseType") {
            const entity = editTarget.entity;
            setName(entity.name);
            setDescription(entity.description ?? "");
            setFolderNumber(entity.folderNumber ?? "");
            setIsDefault(!!entity.isDefault);
            setIsUnique(!!entity.isUniquePerMilestone);
            setIsSubCaseOnly(!!entity.isSubCaseOnly);
            setMilestoneTypeId(entity.milestoneTypeId ?? "");
            setParentCaseTypeIds(data.subCaseTypeLinks
                .filter((link) => link.subCaseTypeId === entity.id)
                .map((link) => link.parentCaseTypeId));
            setTemplateName(entity._templateName ?? "");
            setTemplateDescription(entity._templateDescription ?? "");
            setTaskTemplates((entity._taskTemplates ?? []).map((t) => ({ name: t.name, description: t.description, status: t.status })));
            return;
        }
        setName("");
        setDescription("");
        setFolderNumber("");
        setIsDefault(false);
        setIsUnique(false);
        setIsSubCaseOnly(false);
        setParentCaseTypeIds([]);
        setTemplateName("");
        setTemplateDescription("");
        setTaskTemplates([]);
        setMilestoneTypeId(defaultMilestoneTypeId ?? "");
    }, [kind, editTarget, defaultMilestoneTypeId, milestoneEdge?.folderNumber, milestoneEdge?.isDefault]);
    if (!kind && !editTarget)
        return null;
    // Numer folderu kamienia to CHAR(2) - także wtedy, gdy podpinamy istniejący typ.
    const maxFolderLength = isMilestone || isAttach ? 2 : 8;
    const isNameLocked = !!editTarget && editTarget.entity._isNameLocked;
    const usageCount = editTarget?.entity._usageCount ?? 0;
    /**
     * Rozjazd, który ISTNIAŁ przed otwarciem okna: pozycja oznaczona jako domyślna,
     * ale bez szablonu, więc mimo flagi nie powstawała. Liczymy ze stanu ZAPISANEGO,
     * nie z pola formularza - inaczej komunikat wyskakiwałby każdemu, kto właśnie
     * zaznacza przełącznik po raz pierwszy.
     */
    const hadTemplateGap = !editTarget
        ? false
        : editTarget.kind === "milestoneType"
            ? !!milestoneEdge?.isDefault && editTarget.entity._templateId === null
            : editTarget.entity.isDefault && editTarget.entity._templateId === null;
    /**
     * Ustawienia tworzenia pokazujemy tylko wtedy, gdy szablon istnieje albo powstanie.
     * W stanie „nie powstaje samo i szablonu nie ma” te pola nie miałyby gdzie trafić,
     * więc ich obecność wprowadzałaby w błąd.
     */
    const showTemplateSection = isDefault || (!!editTarget && editTarget.entity._templateId !== null);
    /** Komunikaty pokazujemy dopiero po próbie zapisu, żeby pusty formularz nie krzyczał. */
    const nameError = name.trim().length === 0 ? "Podaj nazwę." : null;
    const folderError = folderNumber.trim().length === 0
        ? "Podaj numer folderu."
        : folderNumber.trim().length > maxFolderLength
            ? `Numer folderu może mieć najwyżej ${maxFolderLength} znaki.`
            : null;
    const milestoneError = !isMilestone && !isEditing && milestoneTypeId === "" ? "Wybierz kamień milowy." : null;
    const descriptionError = description.length > 250 ? "Opis może mieć najwyżej 250 znaków." : null;
    // Typ „wyłącznie podsprawa” bez rodzica byłby niewidoczny w całym systemie:
    // nie pojawia się przy zakładaniu zwykłej sprawy, a bez powiązania nie ma
    // też pod czym wystąpić.
    const parentsError = !isMilestone && isSubCaseOnly && parentCaseTypeIds.length === 0
        ? "Wskaż co najmniej jedną sprawę nadrzędną."
        : null;
    const attachError = isAttach && milestoneTypeId === "" ? "Wybierz typ kamienia." : null;
    // Przy podpinaniu nie ma pól typu, więc nie ma czego walidować poza wyborem i numerem.
    const hasErrors = isAttach
        ? !!(attachError || folderError)
        : !!(nameError || folderError || milestoneError || descriptionError || parentsError);
    /** Możliwi rodzice: sprawy z tego samego kamienia, poza samym sobą i innymi podsprawami. */
    const effectiveMilestoneTypeId = editTarget?.kind === "caseType"
        ? editTarget.entity.milestoneTypeId
        : milestoneTypeId === ""
            ? null
            : Number(milestoneTypeId);
    const parentOptions = data.caseTypes.filter((candidate) => candidate.milestoneTypeId === effectiveMilestoneTypeId &&
        !candidate.isSubCaseOnly &&
        candidate.id !== editTarget?.entity.id);
    function toggleParent(id) {
        setParentCaseTypeIds((current) => current.includes(id) ? current.filter((value) => value !== id) : [...current, id]);
    }
    const milestoneOptions = contractTypeId === null
        ? []
        : (0, typesTreeModel_1.milestoneTypesForContractType)(data, contractTypeId).map((entry) => entry.milestoneType);
    /**
     * Kandydaci do podpięcia: typy kamieni, których ten typ umowy jeszcze nie ma.
     *
     * Bez kamieni ofertowych - te należą do gałęzi ofert, a nie do umów, i kod
     * odwołuje się do nich po numerze. Serwer odrzuca je niezależnie od tej listy.
     */
    const attachOptions = contractTypeId === null
        ? []
        : data.milestoneTypes
            .filter((type) => !data.contractTypeMilestoneTypes.some((edge) => edge.contractTypeId === contractTypeId &&
            edge.milestoneTypeId === type.id) &&
            !data.offerMilestoneTypes.some((edge) => edge.milestoneTypeId === type.id))
            .sort((first, second) => first.name.localeCompare(second.name, "pl"));
    const selectedAttachType = milestoneTypeId === ""
        ? undefined
        : data.milestoneTypes.find((type) => type.id === Number(milestoneTypeId));
    function handleSubmit() {
        setWasSubmitted(true);
        if (isAttach) {
            if (hasErrors || contractTypeId === null)
                return;
            onSubmit("attachMilestoneType", {
                milestoneTypeId: Number(milestoneTypeId),
                contractTypeId,
                // Numer folderu jedzie jako tekst - serwer parsuje wartości ciała
                // żądania i samo "9" dotarłoby tam jako liczba.
                folderNumber: String(folderNumber).trim(),
                isDefault,
            });
            return;
        }
        if (hasErrors || (isMilestone && contractTypeId === null))
            return;
        if (isMilestone) {
            onSubmit("milestoneType", {
                name: name.trim(),
                description: description.trim(),
                isUniquePerContract: isUnique,
                isInScrumByDefault: false,
                contractTypeId,
                // Numer folderu jedzie jako tekst - serwer parsuje wartości ciała
                // żądania i samo "9" dotarłoby tam jako liczba.
                folderNumber: String(folderNumber).trim(),
                isDefault,
                templateName: showTemplateSection ? templateName.trim() : "",
                templateDescription: showTemplateSection ? templateDescription.trim() : "",
            }, editTarget?.entity.id);
            return;
        }
        onSubmit("caseType", {
            milestoneTypeId: milestoneTypeId === "" ? undefined : Number(milestoneTypeId),
            name: name.trim(),
            description: description.trim(),
            folderNumber: String(folderNumber).trim(),
            isDefault,
            isUniquePerMilestone: isUnique,
            isInScrumByDefault: false,
            isSubCaseOnly,
            parentCaseTypeIds,
            templateName: showTemplateSection ? templateName.trim() : "",
            templateDescription: showTemplateSection ? templateDescription.trim() : "",
            taskTemplates: showTemplateSection ? taskTemplates.filter((t) => t.name.trim().length > 0) : [],
        }, editTarget?.entity.id);
    }
    const contractTypeName = data.contractTypes.find((type) => type.id === contractTypeId)?.name ?? "";
    const milestoneName = editTarget?.kind === "caseType"
        ? data.milestoneTypes.find((type) => type.id === editTarget.entity.milestoneTypeId)?.name
        : undefined;
    const titleAction = isEditing ? "Edytuj" : "Dodaj";
    const titleSubject = isMilestone ? "typ kamienia milowego" : "typ sprawy";
    const heading = isAttach
        ? "Podepnij istniejący typ kamienia"
        : `${titleAction} ${titleSubject}`;
    /**
     * W panelu bocznym (352 px) kolumny stojące obok siebie zwężają się do pól,
     * w których nie widać własnego tekstu - tam wszystko idzie jedna pod drugą.
     * W oknie modalnym (szerokie `size="lg"`) zostaje układ dotychczasowy.
     */
    const col = (panel, modal) => (isEditing ? panel : modal);
    const body = (react_1.default.createElement(react_1.default.Fragment, null,
        error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "py-2 small" }, error)),
        isEditing && usageCount > 0 && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "py-2 small" },
            "Ten typ jest u\u017Cyty ",
            react_1.default.createElement("strong", null, usageCount),
            " raz(y). Zmiana nazwy albo numeru folderu nie przemianuje folder\u00F3w ju\u017C istniej\u0105cych na Dysku - dotyczy tylko tych, kt\u00F3re dopiero powstan\u0105.")),
        isNameLocked && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "secondary", className: "py-2 small" }, "Nazwa jest zablokowana, bo kod odwo\u0142uje si\u0119 do tego typu wprost. Pozosta\u0142e pola mo\u017Cna zmienia\u0107.")),
        isMilestone ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "py-2 small border" },
            isEditing ? "Numer folderu dotyczy powiązania z typem umowy " : "Nowy kamień zostanie powiązany z typem umowy ",
            react_1.default.createElement("strong", null, contractTypeName),
            ".")) : isEditing ? (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Kamie\u0144 milowy"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { value: milestoneName ?? "bez kamienia", disabled: true }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Kamienia nie da si\u0119 zmieni\u0107 - istniej\u0105ce sprawy zosta\u0142yby przypi\u0119te do typu wisz\u0105cego pod innym kamieniem."))) : (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Kamie\u0144 milowy"),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { value: milestoneTypeId, isInvalid: wasSubmitted && !!milestoneError, onChange: (event) => setMilestoneTypeId(event.target.value ? Number(event.target.value) : "") },
                react_1.default.createElement("option", { value: "" }, "Wybierz kamie\u0144"),
                milestoneOptions.map((type) => (react_1.default.createElement("option", { key: type.id, value: type.id }, type.name)))),
            react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, milestoneError))),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: col(12, 8), className: "mb-3" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nazwa"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { value: name, disabled: isNameLocked, isInvalid: wasSubmitted && !!nameError, onChange: (event) => setName(event.target.value), autoFocus: !isNameLocked }),
                react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, nameError)),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: col(12, 4), className: "mb-3" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Numer folderu"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { value: folderNumber, maxLength: maxFolderLength, placeholder: isMilestone ? "np. 09" : "np. 04.03", isInvalid: wasSubmitted && !!folderError, onChange: (event) => setFolderNumber(event.target.value) }),
                react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, folderError),
                react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true },
                    "Maks. ",
                    maxFolderLength,
                    " znaki."))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Opis"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, value: description, isInvalid: wasSubmitted && !!descriptionError, onChange: (event) => setDescription(event.target.value) }),
            react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, descriptionError)),
        react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Powstaje automatycznie przy nowej umowie", checked: isDefault, onChange: (event) => setIsDefault(event.target.checked) }),
        hadTemplateGap && (react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "text-warning d-block" }, "Dot\u0105d nie powstawa\u0142o, mimo zaznaczenia - brakowa\u0142o szablonu. Zapis to naprawi.")),
        !showTemplateSection && (react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true, className: "d-block" },
            "Zaznacz, \u017Ceby ustawi\u0107 nazw\u0119 i ",
            isMilestone ? "opis" : "zadania startowe",
            " pozycji tworzonej automatycznie.")),
        showTemplateSection && (react_1.default.createElement("div", { className: "border rounded p-2 mt-2 mb-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "small mb-1" },
                    "Nazwa ",
                    isMilestone ? "tworzonego kamienia" : "tworzonej sprawy"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { size: "sm", value: templateName, placeholder: "puste = nazwa typu", onChange: (event) => setTemplateName(event.target.value) })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "small mb-1" },
                    "Opis ",
                    isMilestone ? "tworzonego kamienia" : "tworzonej sprawy"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, size: "sm", value: templateDescription, onChange: (event) => setTemplateDescription(event.target.value) })),
            isMilestone && (react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Nazwa jest wsp\u00F3lna dla wszystkich typ\u00F3w um\u00F3w u\u017Cywaj\u0105cych tego kamienia - to, czy kamie\u0144 powstaje, ustawia si\u0119 osobno dla ka\u017Cdego typu umowy.")))),
        react_1.default.createElement(react_bootstrap_1.Form.Check, { className: "mt-2", type: "switch", label: isMilestone ? "Unikalny w ramach umowy" : "Unikalny w ramach kamienia", checked: isUnique, onChange: (event) => setIsUnique(event.target.checked) }),
        !isMilestone && (react_1.default.createElement(react_1.default.Fragment, null,
            showTemplateSection && (react_1.default.createElement("div", { className: "mt-2" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1" }, "Zadania zak\u0142adane razem ze spraw\u0105"),
                taskTemplates.length === 0 && (react_1.default.createElement("div", { className: "text-muted small mb-2" }, "Brak - sprawa powstanie pusta.")),
                taskTemplates.map((task, index) => (react_1.default.createElement(react_bootstrap_1.Row, { key: index, className: "g-1 mb-1 align-items-start" },
                    react_1.default.createElement(react_bootstrap_1.Col, { md: col(12, 4) },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { size: "sm", placeholder: "Nazwa zadania", value: task.name, onChange: (event) => setTaskTemplates((current) => current.map((item, i) => i === index ? { ...item, name: event.target.value } : item)) })),
                    react_1.default.createElement(react_bootstrap_1.Col, { md: col(12, 4) },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { size: "sm", placeholder: "Opis", value: task.description, onChange: (event) => setTaskTemplates((current) => current.map((item, i) => i === index
                                ? { ...item, description: event.target.value }
                                : item)) })),
                    react_1.default.createElement(react_bootstrap_1.Col, { md: col(9, 3) },
                        react_1.default.createElement(react_bootstrap_1.Form.Select, { size: "sm", value: task.status, onChange: (event) => setTaskTemplates((current) => current.map((item, i) => i === index ? { ...item, status: event.target.value } : item)) },
                            react_1.default.createElement("option", { value: "" }, "Nie rozpocz\u0119ty"),
                            react_1.default.createElement("option", { value: "Backlog" }, "Backlog"))),
                    react_1.default.createElement(react_bootstrap_1.Col, { md: col(3, 1) },
                        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", className: "w-100", title: "Usu\u0144 zadanie", onClick: () => setTaskTemplates((current) => current.filter((_, i) => i !== index)) }, "\u00D7"))))),
                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-success", onClick: () => setTaskTemplates((current) => [
                        ...current,
                        { name: "", description: "", status: "" },
                    ]) }, "Dodaj zadanie"))),
            react_1.default.createElement(react_bootstrap_1.Form.Check, { className: "mt-3", type: "switch", label: "Wy\u0142\u0105cznie jako podsprawa", checked: isSubCaseOnly, onChange: (event) => setIsSubCaseOnly(event.target.checked) }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Taki typ nie pojawi si\u0119 przy zak\u0142adaniu zwyk\u0142ej sprawy."),
            react_1.default.createElement("div", { className: "mt-3" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1" },
                    "Sprawy nadrz\u0119dne",
                    !isSubCaseOnly && " (opcjonalnie)"),
                parentOptions.length === 0 ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "py-2 small mb-0" }, "Ten kamie\u0144 nie ma jeszcze zwyk\u0142ych typ\u00F3w spraw, pod kt\u00F3re mo\u017Cna podpi\u0105\u0107 podspraw\u0119. Najpierw dodaj typ sprawy, potem wr\u00F3\u0107 tutaj.")) : (react_1.default.createElement("div", { className: `border rounded p-2 ${wasSubmitted && parentsError ? "border-danger" : ""}`, style: { maxHeight: 180, overflowY: "auto" } }, parentOptions.map((candidate) => (react_1.default.createElement(react_bootstrap_1.Form.Check, { key: candidate.id, type: "checkbox", id: `parentCaseType-${candidate.id}`, label: `${candidate.folderNumber ?? ""} ${candidate.name}`.trim(), checked: parentCaseTypeIds.includes(candidate.id), onChange: () => toggleParent(candidate.id) }))))),
                wasSubmitted && parentsError && (react_1.default.createElement("div", { className: "text-danger small mt-1" }, parentsError)),
                react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true },
                    "Ten sam typ mo\u017Ce by\u0107 dopuszczony pod kilkoma sprawami - w drzewie rysujemy go wtedy jako jeden w\u0119ze\u0142 z kilkoma liniami.",
                    !isSubCaseOnly && parentCaseTypeIds.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                        " ",
                        "Ten typ mo\u017Cna za\u0142o\u017Cy\u0107 zar\u00F3wno jako zwyk\u0142\u0105 spraw\u0119, jak i jako podspraw\u0119. Odznacz wszystkie sprawy nadrz\u0119dne, \u017Ceby zosta\u0142 wy\u0142\u0105cznie zwyk\u0142\u0105 spraw\u0105."))))))));
    /**
     * Formularz podpinania. Krótki celowo: nazwa, opis i pozostałe ustawienia należą
     * do samego typu i są wspólne dla wszystkich typów umów, więc dawanie ich tutaj
     * kusiłoby do zmiany, która uderzyłaby w pozostałe typy umów.
     */
    const attachBody = (react_1.default.createElement(react_1.default.Fragment, null,
        error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "py-2 small" }, error)),
        react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "py-2 small border" },
            "Typ zostanie podpi\u0119ty do typu umowy ",
            react_1.default.createElement("strong", null, contractTypeName),
            ". Ustawiasz tu tylko to, co nale\u017Cy do powi\u0105zania - nazwa i opis zostaj\u0105 takie, jakie typ ma dzi\u015B."),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Typ kamienia"),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { value: milestoneTypeId, isInvalid: wasSubmitted && !!attachError, onChange: (event) => setMilestoneTypeId(event.target.value === "" ? "" : Number(event.target.value)) },
                react_1.default.createElement("option", { value: "" }, "-- wybierz --"),
                attachOptions.map((type) => (react_1.default.createElement("option", { key: type.id, value: type.id }, type.name)))),
            react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, attachError),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Lista pomija typy, kt\u00F3re ten typ umowy ju\u017C ma. Typy spraw jad\u0105 razem z kamieniem - osobno si\u0119 ich nie podpina.")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Numer folderu"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { value: folderNumber, isInvalid: wasSubmitted && !!folderError, onChange: (event) => setFolderNumber(event.target.value) }),
            react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, folderError),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Numer nale\u017Cy do tego typu umowy i nie musi by\u0107 w nim niepowtarzalny - typ wycofywany mo\u017Ce zachowa\u0107 sw\u00F3j, a nowy przej\u0105\u0107 ten sam.")),
        react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Powstaje automatycznie przy nowej umowie", checked: isDefault, onChange: (event) => setIsDefault(event.target.checked) }),
        isDefault && selectedAttachType?._templateId === null && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "py-2 small mt-2" }, "Ten typ nie ma szablonu kamienia, wi\u0119c mimo zaznaczenia nic nie powstanie. Szablon dodaje si\u0119 przy edycji samego typu - i obowi\u0105zuje wtedy wszystkie typy um\u00F3w."))));
    const buttons = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: onClose, disabled: isSaving }, "Anuluj"),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: handleSubmit, disabled: isSaving }, isSaving ? react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm" }) : "Zapisz")));
    // Edycja typu idzie PANELEM BOCZNYM (decyzja D2 planu): szczegóły widać obok
    // drzewa, a nie zamiast drzewa. `backdrop={false}` i `scroll` zostawiają drzewo
    // widoczne i klikalne, dzięki czemu klik w sąsiedni kafel PODMIENIA treść panelu
    // zamiast go zamykać i otwierać od nowa.
    //
    // Dodawanie („Dodaj kamień milowy", „Dodaj typ sprawy") zostaje oknem modalnym -
    // tam kontekst drzewa nic nie wnosi, a wymuszone domknięcie jest zaletą.
    if (isEditing)
        return (react_1.default.createElement(react_bootstrap_1.Offcanvas, { show: true, onHide: onClose, placement: "end", backdrop: false, scroll: true, "data-testid": "types-tree-panel", style: { width: exports.TYPES_PANEL_WIDTH } },
            react_1.default.createElement(react_bootstrap_1.Offcanvas.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Offcanvas.Title, { className: "fs-5" }, heading)),
            react_1.default.createElement(react_bootstrap_1.Offcanvas.Body, null,
                body,
                react_1.default.createElement("div", { className: "d-flex justify-content-end gap-2 mt-3" }, buttons))));
    return (
    // Szerzej niż domyślnie: wiersz zadania startowego to nazwa, opis, status
    // i przycisk usuwania - w wąskim oknie zwijają się do nieczytelnych pól.
    //
    // BEZ `centered`: wyśrodkowane w pionie okno przy każdej zmianie wysokości
    // przelicza swoje położenie, więc rozwinięcie ustawień tworzenia przesuwało
    // w górę całą treść i przełącznik uciekał spod kursora. Okno zakotwiczone
    // u góry rośnie tylko w dół, a to, co nad zmianą, zostaje na miejscu.
    react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: onClose, size: "lg" },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, { className: "fs-5" }, heading)),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null, isAttach ? attachBody : body),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null, buttons)));
}
